package org.multipaz.utopia.generated

/**
 * Generated strings for language: zh-rCN
 * DO NOT EDIT - This file is auto-generated by the generateMultipazStrings task
 */
internal val strings_zh_rCN = mapOf(
    "boarding_pass_attribute_departure_time" to "出发时间",
    "boarding_pass_attribute_flight_number" to "航班号",
    "boarding_pass_attribute_passenger_name" to "乘客姓名",
    "boarding_pass_attribute_seat_number" to "座位号",
    "boarding_pass_description_departure_time" to "出发日期和时间",
    "boarding_pass_description_flight_number" to "航班号",
    "boarding_pass_description_passenger_name" to "mDL持有者的姓氏、名或主要身份标识。",
    "boarding_pass_description_seat_number" to "座位号",
    "cor_attribute_administrative_number" to "管理号",
    "cor_attribute_date_of_arrival" to "抵达日期",
    "cor_attribute_date_of_birth" to "出生日期",
    "cor_attribute_date_of_expiry" to "有效期至",
    "cor_attribute_date_of_issue" to "签发日期",
    "cor_attribute_document_number" to "证件号码",
    "cor_attribute_family_name" to "姓氏",
    "cor_attribute_gender" to "性别",
    "cor_attribute_given_names" to "名字",
    "cor_attribute_issuing_authority" to "签发机关",
    "cor_attribute_issuing_country" to "签发国家",
    "cor_attribute_issuing_jurisdiction" to "签发管辖区",
    "cor_attribute_nationality" to "国籍",
    "cor_attribute_older_than_18" to "18岁以上",
    "cor_attribute_older_than_21" to "21岁以上",
    "cor_attribute_place_of_birth" to "出生地",
    "cor_attribute_resident_address" to "居住地址",
    "cor_attribute_resident_city" to "居住城市",
    "cor_attribute_resident_country" to "居住国家",
    "cor_attribute_resident_house_number" to "居住门牌号",
    "cor_attribute_resident_postal_code" to "居住邮政编码",
    "cor_attribute_resident_state" to "居住州",
    "cor_attribute_resident_street" to "居住街道",
    "cor_description_administrative_number" to "由 COR 提供方分配用于审计控制或其他目的的编号。",
    "cor_description_date_of_arrival" to "COR持有人抵达欧盟的日期（日、月、年）。",
    "cor_description_date_of_birth" to "COR持有人的出生日期（日、月、年）。如果未知，请填写大概出生日期。",
    "cor_description_date_of_expiry" to "COR的有效期截止日期（可能包括时间）。",
    "cor_description_date_of_issue" to "COR的签发日期（可能包括时间）。",
    "cor_description_document_number" to "由 COR 提供方分配的 COR 编号。",
    "cor_description_family_name" to "COR持有人的当前姓氏、家族名或主要身份标识",
    "cor_description_gender" to "COR持有人的性别。",
    "cor_description_given_names" to "COR持有人的当前名字、其他姓名或次要身份标识",
    "cor_description_issuing_authority" to "签发此 COR 实例的行政机构名称，或在无单独签发机构时，为相应成员国的 ISO 3166 Alpha-2 国家代码。",
    "cor_description_issuing_country" to "签发机构所属国家或地区的 Alpha-2 国家代码，定义见 ISO 3166-1。",
    "cor_description_issuing_jurisdiction" to "签发 COR 的司法管辖区的国家细分代码，定义见 ISO 3166-2:2020 第 8 条。代码的第一部分应与签发国家/地区的值相同。",
    "cor_description_nationality" to "ISO 3166-1中规定的Alpha-2国家代码，表示用户国籍。",
    "cor_description_older_than_18" to "年龄是否大于18岁？",
    "cor_description_older_than_21" to "年龄是否大于21岁？",
    "cor_description_place_of_birth" to "COR持有人的出生地。",
    "cor_description_resident_address" to "COR持有人当前居住和/或可联系地点的完整地址（街道/门牌号、市等）。",
    "cor_description_resident_city" to "COR持有人当前居住的城市。",
    "cor_description_resident_country" to "用户当前居住的国家，以ISO 3166-1中规定的Alpha-2国家代码形式表示。",
    "cor_description_resident_house_number" to "用户当前居住的门牌号，包括任何前缀或后缀。",
    "cor_description_resident_postal_code" to "COR持有人当前居住地的邮政编码。",
    "cor_description_resident_state" to "用户当前居住的州、省、区或当地区域。",
    "cor_description_resident_street" to "用户当前居住的街道名称。",
    "cor_request_age_over_18" to "年龄超过18岁",
    "cor_request_all_data_elements" to "所有数据要素",
    "cor_request_mandatory_data_elements" to "必填数据要素",
    "document_display_name_boarding_pass" to "登机牌",
    "document_display_name_certificate_of_residency" to "居住证明",
    "document_display_name_german_personal_id" to "德国身份证",
    "document_display_name_loyalty_card" to "会员卡",
    "document_display_name_movie_ticket" to "电影票",
    "document_display_name_naturalization_certificate" to "入籍证书",
    "document_display_name_payment_card" to "支付卡",
    "german_id_attribute_administrative_number" to "行政编号",
    "german_id_attribute_age_in_years" to "年龄（岁）",
    "german_id_attribute_city_of_birth" to "出生城市",
    "german_id_attribute_country_of_birth" to "出生国家",
    "german_id_attribute_date_of_birth" to "出生日期",
    "german_id_attribute_date_of_expiry" to "到期日期",
    "german_id_attribute_date_of_issue" to "签发日期",
    "german_id_attribute_document_number" to "证件号码",
    "german_id_attribute_family_name" to "姓",
    "german_id_attribute_family_name_at_birth" to "出生姓氏",
    "german_id_attribute_gender" to "性别",
    "german_id_attribute_given_names" to "名字",
    "german_id_attribute_issuing_authority" to "签发机关",
    "german_id_attribute_issuing_country" to "签发国家",
    "german_id_attribute_issuing_jurisdiction" to "签发辖区",
    "german_id_attribute_nationality" to "国籍",
    "german_id_attribute_older_than_12" to "12岁以上",
    "german_id_attribute_older_than_14" to "14岁以上",
    "german_id_attribute_older_than_16" to "16岁以上",
    "german_id_attribute_older_than_18" to "18岁以上",
    "german_id_attribute_older_than_21" to "21岁以上",
    "german_id_attribute_older_than_65" to "65岁以上",
    "german_id_attribute_place_of_birth" to "出生地",
    "german_id_attribute_resident_address" to "居住地址",
    "german_id_attribute_resident_city" to "居住城市",
    "german_id_attribute_resident_country" to "居住国家",
    "german_id_attribute_resident_postal_code" to "居住邮政编码",
    "german_id_attribute_state_of_birth" to "出生州",
    "german_id_attribute_year_of_birth" to "出生年份",
    "german_id_description_administrative_number" to "由PID提供方分配的编号，用于审计控制或其他目的。",
    "german_id_description_age_in_years" to "PID 持有人的周岁年龄",
    "german_id_description_city_of_birth" to "PID用户出生的行政区、市、镇或村庄",
    "german_id_description_country_of_birth" to "持证人出生国家，采用ISO 3166-1规定的Alpha-2国家代码",
    "german_id_description_date_of_birth" to "PID 持有人出生的日期、月份和年份。如果未知，请提供大概出生日期。",
    "german_id_description_date_of_expiry" to "PID的到期日期（可能包含时间）",
    "german_id_description_date_of_issue" to "PID的签发日期（可能包含时间）",
    "german_id_description_document_number" to "由PID提供方分配的PID编号。",
    "german_id_description_family_name" to "PID 持有人的当前姓氏、氏族名或主要标识符",
    "german_id_description_family_name_at_birth" to "出生时姓氏，或持证人出生时的主要身份标识",
    "german_id_description_gender" to "PID持有者的性别",
    "german_id_description_given_names" to "PID 持有人的当前名字、其他名字或次要标识符",
    "german_id_description_issuing_authority" to "签发此PID实例的行政机构名称，或在无单独PID签发机构时，为相应成员国的ISO 3166 Alpha-2国家代码。",
    "german_id_description_issuing_country" to "签发机构所属国家或地区的ISO 3166-1 Alpha-2国家代码。",
    "german_id_description_issuing_jurisdiction" to "签发PID的司法管辖区的国家细分代码，按照ISO 3166-2:2020第8条规定。代码首部分须与\"签发国家\"的值相同。",
    "german_id_description_nationality" to "代表PID用户国籍的 Alpha-2 国家代码列表（ISO 3166-1 规定）",
    "german_id_description_older_than_12" to "年龄超过12岁？",
    "german_id_description_older_than_14" to "年龄超过14岁？",
    "german_id_description_older_than_16" to "年龄超过16岁？",
    "german_id_description_older_than_18" to "年龄超过18岁？",
    "german_id_description_older_than_21" to "年龄超过21岁？",
    "german_id_description_older_than_65" to "年龄超过65岁？",
    "german_id_description_place_of_birth" to "持证人的出生国家和城市或州/省",
    "german_id_description_resident_address" to "PID持有者当前居住和/或可联系的完整地址（街道/门牌号、行政区划等）",
    "german_id_description_resident_city" to "PID持有者当前居住的城市",
    "german_id_description_resident_country" to "PID用户当前居住的国家（ISO 3166-1 规定的 Alpha-2 国家代码）",
    "german_id_description_resident_postal_code" to "PID持有者当前居住地的邮政编码",
    "german_id_description_state_of_birth" to "持证人出生所在的州、省、区或所在地",
    "german_id_description_year_of_birth" to "PID 持有人出生的年份",
    "german_id_request_age_over_18" to "年龄超过 18 岁",
    "german_id_request_all_data_elements" to "所有数据要素",
    "german_id_request_mandatory_data_elements" to "强制数据要素",
    "loyalty_attribute_date_of_expiry" to "到期日期",
    "loyalty_attribute_date_of_issue" to "签发日期",
    "loyalty_attribute_family_name" to "姓氏",
    "loyalty_attribute_given_names" to "名字",
    "loyalty_attribute_membership_id" to "会员ID",
    "loyalty_attribute_photo_of_holder" to "持有者照片",
    "loyalty_attribute_tier" to "级别",
    "loyalty_description_date_of_expiry" to "文件到期日期",
    "loyalty_description_date_of_issue" to "文件签发日期",
    "loyalty_description_family_name" to "持证人的姓氏、家族名或主要身份标识",
    "loyalty_description_given_names" to "持证人的名字、其他名字或次要身份标识",
    "loyalty_description_membership_id" to "忠诚度ID持有人的个人标识符。",
    "loyalty_description_photo_of_holder" to "持证人肖像的复制件。",
    "loyalty_description_tier" to "会员级别（基本、白银、黄金、白金、精英）",
    "loyalty_request_all_data_elements" to "所有数据项",
    "loyalty_request_mandatory_data_elements" to "必填数据项",
    "movie_ticket_attribute_age_rating_code" to "年龄分级代码",
    "movie_ticket_attribute_cinema_theater" to "影院",
    "movie_ticket_attribute_date_and_time_of_show" to "放映日期和时间",
    "movie_ticket_attribute_movie_poster" to "电影海报",
    "movie_ticket_attribute_movie_title" to "电影名称",
    "movie_ticket_attribute_parking" to "停车",
    "movie_ticket_attribute_seat" to "座位",
    "movie_ticket_attribute_theater" to "影院",
    "movie_ticket_attribute_ticket_number" to "票号",
    "movie_ticket_description_age_rating_code" to "电影年龄限制分级代码",
    "movie_ticket_description_cinema_theater" to "影院名称和/或入场地址/地点。",
    "movie_ticket_description_date_and_time_of_show" to "电影开始的日期和时间",
    "movie_ticket_description_movie_poster" to "电影海报",
    "movie_ticket_description_movie_title" to "影片名称、标题以及任何其他场次识别信息。",
    "movie_ticket_description_parking" to "购票时是否预付停车费的标志",
    "movie_ticket_description_seat" to "座位号或编码（例如排/座）",
    "movie_ticket_description_theater" to "多厅影院中影厅的名称或编号",
    "movie_ticket_description_ticket_number" to "购买时发行的票证识别/参考编号。",
    "movie_ticket_request_all_data_elements" to "所有数据元素",
    "movie_ticket_request_prepaid_parking" to "预付停车",
    "movie_ticket_request_ticket_number" to "票号",
    "naturalization_attribute_date_of_birth" to "出生日期",
    "naturalization_attribute_date_of_naturalization" to "归化日期",
    "naturalization_attribute_family_name" to "姓氏",
    "naturalization_attribute_given_names" to "名字",
    "naturalization_description_date_of_birth" to "被归化人的出生日、月、年。如果未知，请提供大概出生日期。",
    "naturalization_description_date_of_naturalization" to "个人获得归化的日期（可能包含时间）。",
    "naturalization_description_family_name" to "被归化人的当前姓氏，或主要身份标识符",
    "naturalization_description_given_names" to "被归化人的当前名字、其他名称，或次要身份标识符",
    "naturalization_request_all_data_elements" to "所有数据元素",
    "payment_attribute_expiry_date" to "有效期",
    "payment_attribute_holder_name" to "持卡人姓名",
    "payment_attribute_issue_date" to "签发日期",
    "payment_attribute_issuer_name" to "签发机构名称",
    "payment_attribute_masked_account_reference" to "遮盖账户参考",
    "payment_attribute_payment_instrument_id" to "支付工具ID",
    "payment_description_expiry_date" to "此凭证的到期日期。",
    "payment_description_holder_name" to "支付账户持有人姓名。",
    "payment_description_issue_date" to "此凭证的签发日期。",
    "payment_description_issuer_name" to "便于识别的发行方名称。",
    "payment_description_masked_account_reference" to "屏蔽的账户参考，例如银行卡号后4位。",
    "payment_description_payment_instrument_id" to "令牌化支付工具标识符。",
    "payment_request_payment_sca_all" to "支付SCA（所有数据元素）",
    "payment_request_payment_sca_minimal" to "支付SCA（最简）",
    "payment_request_payment_sca_transaction" to "SCA支付交易"
)
